import { coerceCalendarDate } from "../../utils/calendarDateKey";
export const dateKeyInZone = (value, timeZone) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(coerceCalendarDate(value));
export const formatStaffTime = (value, timeZone) => {
  const date = coerceCalendarDate(value);
  return date
    ? new Intl.DateTimeFormat("en-US", {
        timeZone,
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      }).format(date)
    : "Not recorded";
};
export const formatCareEvents = (events = []) =>
  events.length
    ? events
        .map(
          (event) =>
            `${event.date} · ${event.time || "Care time: not recorded"}`,
        )
        .join("; ")
    : "date/time not recorded";
export const filterStaffNotes = ({ notes = [], day, view, timeZone }) =>
  notes
    .filter((note) => !note.withdrawn)
    .filter((note) => {
      if (view === "unsigned") return !note.signature;
      if (view === "undated") return !note.version?.careEvents?.length;
      if (view === "documented")
        return (
          note.version &&
          dateKeyInZone(note.version.documentedAt, timeZone) === day
        );
      return note.version?.careEvents?.some((event) => event.date === day);
    })
    .sort(
      (a, b) =>
        new Date(a.version?.documentedAt || 0) -
        new Date(b.version?.documentedAt || 0),
    );
export const unsignedAge = (note, now, timeZone) => {
  const dates =
    note.version?.careEvents?.map((event) => event.date).sort() || [];
  if (!dates.length) return "Care date not recorded";
  const days = Math.floor(
    (Date.parse(`${dateKeyInZone(now, timeZone)}T00:00:00Z`) -
      Date.parse(`${dates[0]}T00:00:00Z`)) /
      86400000,
  );
  return `${Math.max(0, days)} calendar days since care`;
};

export const signingReminder = (note, now, timeZone, reminderDays) => {
  const first = note.version?.careEvents?.map((event) => event.date).sort()[0];
  if (!first || !Number.isInteger(reminderDays)) return "";
  const due = new Date(
    Date.parse(`${first}T00:00:00Z`) + reminderDays * 86400000,
  )
    .toISOString()
    .slice(0, 10);
  return `Reminder due ${due}${dateKeyInZone(now, timeZone) > due ? " · Overdue" : ""}`;
};

export const summarizeStaffNotes = (notes = []) => {
  const active = notes.filter(note => !note.withdrawn);
  return {
    total: active.length,
    withdrawn: notes.length - active.length,
    signed: active.filter(note => note.signature).length,
    pending: active.filter(note => !note.signature).length,
    ready: active.filter(note => !note.signature && note.readiness?.ready && !note.loadError).length,
  };
};
